import { CDK_ROW_TEMPLATE, CdkRow, CdkRowDef } from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, Directive, HostBinding, Input, ViewEncapsulation } from '@angular/core';

/**
 * Data row definition for the table.
 * Captures the data row's template and other properties such as the columns to display and
 * a when predicate that describes when this row should be used.
 */
@Directive({
  selector: '[nRowDef]',
  providers: [{ provide: CdkRowDef, useExisting: NRowDefDirective }],
})
export class NRowDefDirective<T> extends CdkRowDef<T> {
  @Input('nRowDefColumns') override columns: Iterable<string>;
  @Input('nRowDefWhen') override when: (index: number, rowData: T) => boolean;
}

/** Data row template container that contains the cell outlet. Add  s the right class and role. */
@Component({
  selector: 'n-row, tr[n-row]',
  template: CDK_ROW_TEMPLATE,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  // tslint:disable-next-line:validate-decorators
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'nRow',
  providers: [{ provide: CdkRow, useExisting: NRowComponent }],
})
export class NRowComponent extends CdkRow {
  @HostBinding('attr.class') cssClasses = 'n-row ';
  @HostBinding('attr.role') role = 'row';
  @Input() set class(classNames: string) {
    if (classNames) {
      this.cssClasses = `n-row ${classNames}`;
    }
  }
}
